import { getStore } from '@/app/shared/utils/router-guards/shared';

export const isLoggedIn = () => getStore().getters['Auth/isLoggedIn'];

export const hasPermissions = (permissionsPredicate = () => true, routeProps) => {
    const permissions = getStore().getters['User/userPermissions'];
    const user = getStore().state.User.user;

    return permissionsPredicate(permissions, user, routeProps);
};

export const redirectIfUnauthorized =
    (permissionsPredicate = () => true) =>
    (to, from, next) => {
        const hasPermissionGuard = (_to, _from, _next) => {
            const hasAccess = hasPermissions(permissionsPredicate, _to.params);

            if (!hasAccess) {
                return _next({ name: '403' });
            }

            return _next();
        };

        return composeGuards(redirectIfNotLoggedIn, hasPermissionGuard)(to, from, next);
    };

export const redirectIfNotLoggedIn = (to, from, next) => {
    if (!isLoggedIn()) {
        next({
            name: 'Login',
            query: {
                redirectTo: to.fullPath,
            },
        });
        return;
    }

    return next();
};

export const redirectIfNotInGroup =
    (groupCode, redirectRoute = { name: 'Home' }) =>
    (to, from, next) => {
        if (getStore().state.User.user?.is_admin) {
            return next();
        }

        const userGroupCode = getStore().getters['User/userGroupCode'];
        if (userGroupCode !== groupCode) {
            return next(redirectRoute);
        }
        return next();
    };

export const redirectIfFeatureNotEnabled =
    (features, redirectRoute = { name: 'Home' }) =>
    (to, from, next) => {
        const enabledFeatures = getStore().getters['App/enabledFeatures'];
        const hasFeaturesEnabled = (Array.isArray(features) ? features : [features]).every(
            (feature) => enabledFeatures[feature]
        );

        if (!hasFeaturesEnabled) {
            return next(redirectRoute);
        }

        return next();
    };

export const composeGuards =
    (...guards) =>
    async (to, from, next) => {
        let currentNextValue = null;
        const nextFn = (value) => {
            currentNextValue = value;
        };

        for (let i = 0; i < guards.length; i++) {
            await guards[i](to, from, nextFn);
            if (currentNextValue !== undefined) {
                next(currentNextValue);
                return currentNextValue;
            }
        }

        next();
    };
